import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import firebase from 'firebase/app'
require('firebase/firestore')
require('firebase/auth')

// require('firebase/storage')
// require('firebase/functions')

import Notifications from 'vue-notification'

import './registerServiceWorker'

Vue.config.productionTip = false

const firebaseConfig = {
  apiKey: "AIzaSyCN_lfjqJFHfK6pRX_2TKDOOGEbJyEUkRA",
  authDomain: "simpletodo-f1a7d.firebaseapp.com",
  databaseURL: "https://simpletodo-f1a7d.firebaseio.com",
  projectId: "simpletodo-f1a7d",
  storageBucket: "simpletodo-f1a7d.appspot.com",
  messagingSenderId: "1020358138769",
  appId: "1:1020358138769:web:8c9db703beb348fe825830",
  measurementId: "G-X69GHRQCHS"
};

firebase.initializeApp(firebaseConfig)
export const db = firebase.firestore()
export const auth = firebase.auth()
// export const storageRef = firebase.storage().ref()
// export const functions = firebase.functions()

// console.log('hello v3')

Vue.use(Notifications)

// store初期化
store.commit('user/setIsUpdate', false)
auth.onAuthStateChanged(u => {
  if (u) {
    store.commit('user/setUserData', u)
  } else {
    store.commit('user/init')
  }
})

export const vm = new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')

